import { createContext, useContext } from "react";

import type { OutcomeScenariosContextValue } from "./types";

export const OutcomeScenariosContext = createContext<
  OutcomeScenariosContextValue | undefined
>(undefined);

export const useOutcomeScenariosContext = (): OutcomeScenariosContextValue => {
  const context = useContext(OutcomeScenariosContext);

  if (!context) {
    throw new Error(
      "useOutcomeScenariosContext must be used within an OutcomeScenariosProvider",
    );
  }

  return context;
};
